import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type BuyerResponse = OAISchema['MarketBuyerResponse'];
type BuyerPlusMembershipResponse =
  OAISchema['FrontBuyerPlusMembershipResponse'];
type BuyerMyPageResponse = OAISchema['BuyerMyPageResponse'];

export interface BuyerDataSource {
  // Query
  getBuyer(): Promise<BuyerResponse>;
  getBuyerPlusMembership(): Promise<BuyerPlusMembershipResponse>;
  getBuyerMyPage(): Promise<BuyerMyPageResponse>;
}

export class BuyerDataSourceImpl implements BuyerDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getBuyer() {
    return this.client.request<BuyerResponse>({
      url: '/api/market-place/v1/buyer',
      method: 'get',
    });
  }

  async getBuyerPlusMembership() {
    return this.client.request<BuyerPlusMembershipResponse>({
      url: '/api/market-place/v1/buyer/plus-membership',
      method: 'get',
    });
  }

  async getBuyerMyPage() {
    return this.client.request<BuyerMyPageResponse>({
      url: '/api/market-place/v1/buyer/my-page',
      method: 'get',
    });
  }
}

export const buyerDataSource = new BuyerDataSourceImpl();
